import React from 'react';
import { useState, useEffect } from 'react';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import SwimLaneItem from './SwimLaneItem';

function SwimLaneFiltered( props ) {

    const excludedContentIds = ["1_rx30zssd"];
    
    const { name, media, index, toggleModal, playlists } = props;

    function getMediaWithId(id) {
        //console.log('Media Id: ' + id)
        var episode = media.find(ep => {
            return ep.id === id
        });

        return episode;
    }

    function getPlaylistForEpisode(episodeId) {
        //console.log('DEBUG: ' + episodeId)
        var newArr = playlists.filter(function (pl) {
            return pl["playlistContent"].includes(episodeId);
        });

        //return newArr.length > 0 ? newArr[0]["name"] : "No Playlist";
        return newArr.length > 0 ? newArr[0] : { "name": "No Playlist" };
    }

    useEffect(() => {
        //console.log('test')
        //console.log('testing');
    }, [])

    const slideLeft = () => {
        var slider = document.getElementById('slider' + index)
        slider.scrollLeft = slider.scrollLeft - 1500
    }

    const slideRight = () => {
        var slider = document.getElementById('slider' + index)
        slider.scrollLeft = slider.scrollLeft + 1500
    }

    return (
        <div className="items-center">
            <p className="2xl:text-4xl text-2xl font-medium text-gray-100 pl-16">{name}</p>
            <div className="relative flex items-center">
                <MdChevronLeft className="opacity-50 fill-white cursor-pointer hover:opacity-100" onClick={slideLeft} size={40} />
                <div id={'slider' + index} className="w-full h-{100} overflow-x-scroll scroll whitespace-nowrap scroll-smooth scrollbar-hide p-4">
                {media.filter(xMedia => !excludedContentIds.includes(xMedia.Id)).map((episode) => (
                    <SwimLaneItem key={episode["id"]} media={episode} toggleModal={toggleModal} playlist={getPlaylistForEpisode(episode.id)} />
                ))}
                </div>
                <MdChevronRight className="opacity-50 fill-white cursor-pointer hover:opacity-100" onClick={slideRight} size={40} />
            </div>
        </div>
    )
}
export default SwimLaneFiltered